class DrawerSelect extends HTMLElement {
  constructor() {
    super();

    this.pageOverlayClass = "page-overlay";
    this.pageBodyActiveClass = "wt-select-opened";
    this.activeOverlayBodyClass = `${this.pageOverlayClass}-on`;

    this.optionId = this.dataset.optionId;
    this.optionTitleLabel = this.querySelector(
      ".wt-product__option__title .value",
    );
    this.trigger = this.querySelector(".wt-select__trigger");
    this.triggerLabel = this.trigger?.querySelector(
      ".wt-select__trigger__label",
    );
    this.options = this.querySelectorAll(
      ".wt-select__item:not(.wt-select__item--disabled)",
    );
    this.optionName = this.querySelector(
      ".wt-product__option__title .label",
    ).innerText;
    this.form = document.querySelector("form[data-type=add-to-cart-form]");

    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.setOption = this.setOption.bind(this);
    this.setCheckboxOption = this.setCheckboxOption.bind(this);

    this.overlay = document.createElement("div");
    this.inputType = this.dataset.inputType;
  }

  connectedCallback() {
    if (this.inputType === "dropdown") {
      this.createOverlay();
      this.setupListeners();
      this.preselectFirstOption();
    } else {
      this.setupCheckboxListeners();
    }
  }

  disconnectedCallback() {
    this.cleanupListeners();
  }

  setupListeners() {
    this.triggers = this.querySelectorAll(
      ".wt-select__trigger, .page-overlay, .wt-select__drawer__close",
    );

    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", this.toggleDrawer);
    });

    this.options.forEach((option) => {
      option.addEventListener("click", this.setOption);
    });
  }

  setupCheckboxListeners() {
    this.inputCheckbox = this.querySelector(".form-checkbox__input ");
    this.inputCheckbox.addEventListener("click", this.setCheckboxOption);
  }

  cleanupListeners() {
    if (this.inputType === "dropdown") {
      this.triggers.forEach((trigger) => {
        trigger.removeEventListener("click", this.toggleDrawer);
      });

      this.options.forEach((option) => {
        option.removeEventListener("click", this.setOption);
      });
    } else {
      this.inputCheckbox.removeEventListener("click", this.setCheckboxOption);
    }
  }

  toggleDrawer() {
    const body = document.body;
    const drawer = this.querySelector(".wt-select__drawer");
    drawer.classList.toggle("wt-select__drawer--open");
    body.classList.toggle(this.activeOverlayBodyClass);
    body.classList.toggle(this.pageBodyActiveClass);
  }

  setOption(event) {
    const target = event.currentTarget || event;
    const value = target.dataset.value.trim();

    this.triggerLabel.innerHTML = `<span class="value">${value}</span>`;
    this.optionTitleLabel.innerHTML = value;

    this.options.forEach((option) => {
      option.classList.remove("wt-select__item--current");
    });

    target.classList.add("wt-select__item--current");

    this.updateHiddenInput(value);

    if (event.currentTarget) this.toggleDrawer();
  }

  setCheckboxOption(event) {
    const target = event.currentTarget || event;
    const value = event.currentTarget.checked ? target.value : null;
    this.updateHiddenInput(value);
  }

  preselectFirstOption() {
    if (this.options[0]) {
      this.setOption(this.options[0]);
    }
  }

  updateHiddenInput(value) {
    let hiddenInput = this.form.querySelector(
      'input[type="hidden"][name="properties[' + this.optionName + ']"]',
    );
    if (!hiddenInput) {
      hiddenInput = document.createElement("input");
      hiddenInput.type = "hidden";
      hiddenInput.name = "properties[" + this.optionName + "]";
      this.form.appendChild(hiddenInput);
    }
    hiddenInput.value = value;
  }

  createOverlay() {
    if (!this.querySelector(`.${this.pageOverlayClass}`)) {
      this.overlay?.classList.add(this.pageOverlayClass);
      this.appendChild(this.overlay);
    }
  }
}

customElements.define("drawer-select", DrawerSelect);
